import React from "react";
import {MenuItem} from "@/types/uiElements";


interface MenuProps {
    items: MenuItem[];
    onClick?: () => void;
}

const Menu: React.FC<MenuProps> = ({items, onClick}) => {
    return (
        <div className={'flex flex-col gap-[2px] select-none'}>
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    {
                        item.separator ? <div className={`border-b-gray-200 border-b-[1px] ${item?.className || ''}`}></div> :
                            <div
                                key={index}
                                className={` px-md h-[37px] items-center flex flex-row gap-sm text-text-md  transition-all rounded-sm ${item?.disabled ? "opacity-50 cursor-default" : "cursor-pointer hover:bg-primary-100"} ${item?.className || ''}`}
                                onClick={(e) => {
                                    if (item.onClick && !item?.disabled) {
                                        item.onClick?.()
                                        onClick?.()
                                    }
                                    if (item.disabled) {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }
                                }}
                            >
                                <span className='font-icon-solid w-[35px] text-[13px]'>{item.icon}</span>
                                <span className={'pr-md'}>{item.title}</span>
                            </div>
                    }
                </React.Fragment>

            ))}
        </div>
    );
};

export default Menu;
